import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { selectInstruments } from '@app/core/store/capital-structure-slice-selectors';

const useIsCapApplied = () => {
  const instruments = useAppSelector(selectInstruments);

  const isCapApplied = instruments.some(
    (instrument) => instrument.capType !== null && instrument.capValue !== null
  );

  return isCapApplied;
};

export default useIsCapApplied;
